import { getInterface } from '@/utils/js/initVariable';
const prefixUrl = 'api/PolygonClueAreaApi/';

// 查询卫星类型列表，返回 { dataList: string[] }
export const queryScanSatelliteType = (data) => {
  return getInterface.post(`${prefixUrl}queryScanSatelliteType`, data);
}
